// extracted by mini-css-extract-plugin
export default {"tableColumn":"AssociatedRegion_tableColumn__JNXoT"};